import React, { useEffect, useMemo, useState } from "react";

export default function ProductCard({ product, onSelect }) {
  const price = product?.selling_cost ?? product?.product_cost ?? 0;
  const variantItems = useMemo(() => product?.variants || [], [product]);
  const carouselItems = useMemo(() => {
    if (variantItems.length) {
      return variantItems.map((variant) => ({
        src: variant.image_url || null,
        label: variant.label_value || variant.color || variant.size || variant.label || ""
      }));
    }
    const imgs = product?.images && product.images.length ? product.images : product?.image_url ? [product.image_url] : [];
    return imgs.map((src) => ({ src, label: "" }));
  }, [product, variantItems]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, [product?.id]);

  useEffect(() => {
    if (carouselItems.length <= 1) return;
    const timer = window.setInterval(() => {
      setCurrentIndex((idx) => (idx + 1) % carouselItems.length);
    }, 2500);
    return () => window.clearInterval(timer);
  }, [carouselItems.length]);

  const currentItem = carouselItems[currentIndex] || null;

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-lg shadow-lg flex flex-col overflow-hidden">
      <div className="relative aspect-[4/5] bg-black/30">
        {currentItem?.src ? (
          <img
            src={currentItem.src}
            alt={product.image_alt || product.name}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex items-center justify-center h-full text-gray-400 text-xs">
            Image unavailable
          </div>
        )}
        {currentItem?.label ? (
          <div className="absolute left-3 bottom-3 rounded-full bg-black/60 px-3 py-1 text-xs text-white">
            {currentItem.label}
          </div>
        ) : null}
      </div>
      {carouselItems.length > 1 ? (
        <div className="flex items-center justify-center gap-2 py-2">
          {carouselItems.map((_, idx) => (
            <button
              key={`dot-${product?.id || "product"}-${idx}`}
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                setCurrentIndex(idx);
              }}
              className={`h-2.5 w-2.5 rounded-full border border-white/30 ${currentIndex === idx ? "bg-amber-300" : "bg-white/10"}`}
              aria-label={`View variant ${idx + 1}`}
            />
          ))}
        </div>
      ) : null}
      <div className="p-3 flex flex-col gap-2 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-base font-bold text-white line-clamp-2 flex-1">
            {product.product_display_name || product.name}
          </h3>
          <div className="text-lg font-extrabold text-amber-300 whitespace-nowrap">₹{price}</div>
        </div>
        {product.description ? (
          <p className="text-xs text-gray-300 line-clamp-2">{product.description}</p>
        ) : null}
        <button
          onClick={() => onSelect(product)}
          className="mt-auto inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 text-black font-semibold px-3 py-2 text-sm shadow-lg hover:-translate-y-0.5 hover:shadow-amber-400/40 transition"
        >
          Buy Now
        </button>
      </div>
    </div>
  );
}
